export const BungaPosition = [
    {
        "title": "Giro",
        "jan": " 5,865,445,076",
        "feb": "0",
        "mar" : "0",
        "apr": "0",
        "may": "0",
        "jun": "0",
        "jul": "0",
        "aug": "0",
        "sep": "0",
        "oct": "0",
        "nov": "0",
        "dec": "0",
    },
    {
        "title": "NotPool",
        "jan": " 3,590,116,451",
        "feb": "0",
        "mar" : "0",
        "apr": "0",
        "may": "0",
        "jun": "0",
        "jul": "0",
        "aug": "0",
        "sep": "0",
        "oct": "0",
        "nov": "0",
        "dec": "0",
    },{
        "title": "Deposito",
        "jan": " 1,510,341,784",
        "feb": "0",
        "mar" : "0",
        "apr": "0",
        "may": "0",
        "jun": "0",
        "jul": "0",
        "aug": "0",
        "sep": "0",
        "oct": "0",
        "nov": "0",
        "dec": "0",
    },
]